import { BlockTitle } from "@src/app/blocks/Blocks";

type HeaderProps = {
  /** The title of the accordion item, will be displayed at accordion header. */
  title: string;
};

/**
 * component to render SIA accordion header
 */
const SIAAccordionHeader = ({ title }: HeaderProps): React.ReactElement => {
  return (
    <BlockTitle
      text={title}
      rootClassName="text-md mb-0 px-6 py-4 font-poppins font-semibold tracking-2% hover:underline"
    />
  );
};

export default SIAAccordionHeader;
